import { baseApi } from './BaseService';
import {
  CreateDashboardShareTokenRequest,
  CreatedShareToken,
  ListDashboardShareTokensResponse,
} from '../responseTypes/dashboardShareTokens';

const baseUrl = 'admin/dashboard-share-tokens';

export const dashboardShareAdminApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listDashboardShareTokens: build.query<ListDashboardShareTokensResponse, void>({
      query: () => ({
        url: baseUrl,
      }),
      providesTags: [{ type: 'DashboardShareToken', id: 'LIST' }],
    }),
    createDashboardShareToken: build.mutation<
      CreatedShareToken,
      { data: CreateDashboardShareTokenRequest }
    >({
      query: ({ data }) => ({
        url: baseUrl,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'DashboardShareToken', id: 'LIST' }],
    }),
    revokeDashboardShareToken: build.mutation<void, { tokenId: string }>({
      query: ({ tokenId }) => ({
        url: `${baseUrl}/${tokenId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'DashboardShareToken', id: 'LIST' }],
    }),
  }),
});
